import { useDepositConfig } from './useDepositConfig'

export const useDepositUrl = () => {
    const { data, isLoading } = useDepositConfig()
    return {
        url: data ? `https://moonpay.hel.io/deposit/${data.customerToken}` : null,
        isLoading,
    }
}
